const styles = {
  bottomContainer: {
    alignItems: `flex-start`,
    color: `rgb(51, 51, 51)`,
    display: `flex`,
    flexDirection: `column`,
    fontSize: 12.5,
    justifyContent: `space-between`,
    lineHeight: `20px`
  },
  buttonContainer: {
    alignItems: `center`,
    display: `flex`,
    flexDirection: `row`,
    fontSize: 18,
    fontWeight: 300,
    lineHeight: `20px`,
    width: `100%`
  },
  city: {
    marginBottom: 0
  },
  date: {
    color: `rgb(33, 194, 248)`,
    fontSize: 18,
    fontWeight: 300,
    lineHeight: `20px`,
    marginBottom: 6,
    marginTop: 6
  },
  hr: {
    color: `rgb(223, 229, 233)`,
    height: `1px`,
    width: `100%`
  },
  item: {
    border: `solid 1px rgb(223, 229, 233)`,
    boxSizing: `border-box`,
    boxShadow: `0 1px 1px rgba(0,0,0,.05)`,
    display: `flex`,
    flexDirection: `column`,
    fontSize: 11,
    minHeight: `100%`,
    padding: 16,
    margin: `10px 5px`,
    maxWidth: 300,
    minWidth: 265
  },
  itemPrice: {
    minWidth: 100,
    textAlign: `right`
  },
  location: {
    color: `rgb(154, 167, 175)`,
    flexGrow: 1,
    fontSize: 13,
    fontWeight: 300,
    lineHeight: `19px`,
    marginBottom: 0
  },
  spaceBetween: {
    justifyContent: `space-between`
  },
  title: {
    color: `rgb(47, 56, 61)`,
    display: `flex`,
    flexDirection: `row`,
    flexShrink: 0,
    fontSize: 15,
    fontWeight: 300,
    justifyContent: `space-between`,
    lineHeight: `19px`,
    paddingBottom: 8
  },
  warningContainer: {
    backgroundColor: `#ffe998`,
    marginBottom: 15,
    padding: `5px 16px`,
    width: `100%`
  }
};

export default styles;
